/* eslint-disable jsx-a11y/alt-text */
import MediBuddyGold from "../assets/MediBuddyGold.svg";
import DoctorHero from "../assets/DoctorHero.png";
import Titan from "../assets/Titan.png";
import Adobe from "../assets/Adobe.png";
import Sap from "../assets/Sap.png";
import Tcs from "../assets/Tcs.png";
import Cognizant from "../assets/Cognizant.png";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import GetInTouch from "./GetInTouch";

export default function Hero() {
  return (
    <div className="blue-wave">
      <div className="mx-5 md:mx-36 mt-5 lg:flex lg:justify-between">
        <div className="w-full lg:w-5/12 relative top-10">
          <img className="w-96" src={MediBuddyGold} />
          <p className="font-black text-3xl mt-10">
            Essential Healthcare Made Easy For Your Employees
          </p>
          <p className="mt-4 text-lg">
            While you are busy doing what you do best, let us help you take care
            of your employee health and wellness.
          </p>
          <p className="mt-10 text-xl">
            Learn how
            <a
              target="_blank"
              href="https://doctor.medibuddy.in/main.html#gold?popup=show&redirection=gold"
              className="font-black mx-2"
            >
              <span className="medi">Medi</span>
              <span className="buddy">Buddy</span>
              <span className="gold"> Gold</span>
            </a>
            helps your workforce stay healthy.
          </p>
          {/* <Link className="flex space-x-3 shadow-lg items-center mt-10 text-white py-3 px-8 bg-blue-600 rounded-2xl w-48" to="/signup">Sign Up Now <div className="arrow right ml-5"></div></Link> */}
          <p className="mt-10">Trusted By</p>
          <Marquee className="mt-5 mb-10 py-4 overflow-y-hidden flex justify-between bg-white shadow-md rounded-2xl">
            <img className="ml-10" src={Titan} />
            <img className="ml-10" src={Adobe} />
            <img className="ml-10" src={Sap} />
            <img className="ml-10" src={Tcs} />
            <img className="ml-10" src={Cognizant} />
          </Marquee>
        </div>
        <div className="mt-24 lg:mt-0 w-full lg:w-1/2">
          <GetInTouch />
        </div>
      </div>
    </div>
  );
}
